import React from "react";
function NavBar() {
  return (
    <nav>
      <div className="flex flex-col text-white  items-center justify-center">
        <h1> Gtsif Movie Finder </h1>
      </div>
    </nav>
  );
}

export default NavBar;
